import React from 'react';
import SEOHead from '../components/SEOHead';
import Hero from '../components/Hero';
import IntroSection from '../components/IntroSection';
import ServicesOverview from '../components/ServicesOverview';
import FeaturedServices from '../components/FeaturedServices';
import QualityWorkSection from '../components/QualityWorkSection';
import TestimonialSection from '../components/TestimonialSection';
import ServiceAreas from '../components/ServiceAreas';
import ElevationFamily from '../components/ElevationFamily';
import CTASection from '../components/CTASection';
import BeforeAfterShowcase from '../components/BeforeAfterShowcase';
import GoogleReviewsCarousel from '../components/GoogleReviewsCarousel';
import TrustBar from '../components/TrustBar';
import Analytics from '../components/Analytics';
import HolidayDecorations from '../components/decorations/HolidayDecorations';
import { generateElectricianSchema, generateFAQSchema } from '../utils/seoSchemas';
import { buildWebSiteSchema } from '../lib/schema/website';

const HOMEPAGE_FAQS = [
  { question: "What areas does Elevation Electrical serve?", answer: "We serve Volusia, Seminole, and Orange counties including Lake Helen, DeLand, Deltona, Daytona Beach, Orlando, Sanford, and 30+ surrounding cities within a 50-mile radius of our Lake Helen headquarters." },
  { question: "Is Elevation Electrical licensed and insured?", answer: "Yes. We hold Florida Electrical Contractor License EC13011028 issued by the Department of Business and Professional Regulation. We are fully licensed and insured for residential and commercial electrical work." },
  { question: "How much does an electrical panel upgrade cost in Florida?", answer: "Panel upgrades in Central Florida typically range from $2,000 to $6,000 depending on amperage (100A to 200A or 400A), panel brand, and any additional circuit work required. We provide free written estimates." },
  { question: "Do you install whole-home generators?", answer: "Yes. We have completed 470+ generator installations since 2005. We install Generac, Kohler, and Cummins standby generators sized for Florida homes, with automatic transfer switches for seamless hurricane backup power." },
  { question: "How much does EV charger installation cost?", answer: "Level 2 EV charger installation in Central Florida costs $1,200–$3,500 including labor, materials, and permitting. A federal tax credit of up to $1,000 (IRC 30C) is available through June 2026." },
  { question: "Can you do same-day emergency electrical repairs?", answer: "Yes. We offer same-day emergency electrical service throughout our service area. Call 407-970-7211 for immediate assistance with electrical emergencies." }
];

const Index = () => {
  return (
    <>
      <Analytics />
      <SEOHead
        title="Licensed Electrician in Central Florida | Elevation Electrical"
        description="Licensed electrician serving Volusia, Seminole, Orange & Flagler counties. Generator installs, panel upgrades, EV chargers. EC13011028. Call 407-970-7211."
        canonical="https://www.elevationelectricalfl.com/"
        schema={[
          generateElectricianSchema(),
          buildWebSiteSchema(),
          generateFAQSchema(HOMEPAGE_FAQS),
        ]}
      />
      
      {/* Dynamic Holiday Decorations */}
      <HolidayDecorations />
      
      <div>
        {/* Hero Section */}
        <Hero />

        {/* Unified Google Reviews carousel (Phase 2A) — appears above the fold
            on every public route via CityPageLayout / ServicePageLayout; here
            it is included explicitly because the homepage does not use those. */}
        <GoogleReviewsCarousel />

        {/* Phase 2B: trust strip — license, family-owned, same-day, 24/7,
            warranty, BBB. Placed directly below reviews per the prompt. */}
        <TrustBar />

        {/* Intro Section */}
        <IntroSection />
        
        {/* Elevation Family Section */}
        <ElevationFamily />
        
        {/* Services Overview */}
        <ServicesOverview />
        
        {/* Featured Services */}
        <FeaturedServices />
        
        {/* Before/After Panel Upgrade Showcase */}
        <div className="section bg-lightgray py-8 md:py-10">
          <div className="container-custom">
            <BeforeAfterShowcase />
          </div>
        </div>
        
        {/* Additional Quality Work Section */}
        <QualityWorkSection />
        
        {/* Testimonials */}
        <TestimonialSection />

        {/* Phase 2A: the former "Industry Partners" block has been removed.
            The unified GoogleReviewsCarousel above replaces it as the single
            canonical reviews surface — partner quotes were not customer
            reviews and mixing them was misleading. */}

        {/* Service Areas */}
        <ServiceAreas />

        {/* Homepage FAQ Section */}
        <div className="section bg-lightgray py-12">
          <div className="container-custom">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-3xl font-bold text-navy mb-8 text-center">Frequently Asked Questions</h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold text-navy mb-2">What areas does Elevation Electrical serve?</h3>
                  <p>We serve Volusia, Seminole, and Orange counties including Lake Helen, DeLand, Deltona, Daytona Beach, Orlando, Sanford, and 30+ surrounding cities within a 50-mile radius of our Lake Helen headquarters.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-navy mb-2">Is Elevation Electrical licensed and insured?</h3>
                  <p>Yes. We hold Florida Electrical Contractor License EC13011028 issued by the Department of Business and Professional Regulation. We are fully licensed and insured for residential and commercial electrical work.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-navy mb-2">How much does an electrical panel upgrade cost in Florida?</h3>
                  <p>Panel upgrades in Central Florida typically range from $2,000 to $6,000 depending on amperage (100A to 200A or 400A), panel brand, and any additional circuit work required. We provide free written estimates.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-navy mb-2">Do you install whole-home generators?</h3>
                  <p>Yes. We have completed 470+ generator installations since 2005. We install Generac, Kohler, and Cummins standby generators sized for Florida homes, with automatic transfer switches for seamless hurricane backup power.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-navy mb-2">How much does EV charger installation cost?</h3>
                  <p>Level 2 EV charger installation in Central Florida costs $1,200–$3,500 including labor, materials, and permitting. A federal tax credit of up to $1,000 (IRC 30C) is available through June 2026.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-navy mb-2">Can you do same-day emergency electrical repairs?</h3>
                  <p>Yes. We offer same-day emergency electrical service throughout our service area. Call 407-970-7211 for immediate assistance with electrical emergencies.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* CTA Section */}
        <CTASection />
      </div>
    </>
  );
};

export default Index;
